module.exports = __webpack_public_path__ + "img/submit-bg.fdf433f2.png";